import React from 'react';

const MaintenancePageConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/maintenance',
			exact: true,
			component: React.lazy(() => import('./MaintenancePage')),
		},
	],
};

export default MaintenancePageConfig;
